import Loading from "@components/layout/Loading";
import { Box } from "@mantine/core";
import { useFirestoreDocumentMutation } from "@react-query-firebase/firestore";
import { auth, db } from "@utils/firebase";
import { collection, doc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PennyIcon } from "../../assets/icons/penny_icon.svg";
import RequestFollowUpIllustration from "../../assets/illustrations/reuqest_folowup.png";
import ImageWithFallback from "@components/Image/ImageWithFallback";

const RequestFollowUp = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const queryClient = useQueryClient();
  const ref = doc(collection(db, "users"), user?.uid || "a");
  const { mutate, isLoading, isSuccess } = useFirestoreDocumentMutation(ref, {
    merge: true,
  });

  const [redirectTo, setRedirectTo] = useState<"fact-find" | "dashboard" | "">(
    ""
  );
  const [loading, setLoading] = useState(false);

  const handleRequestedFollowUp = (type: "fact-find" | "dashboard") => {
    setLoading(true);
    setRedirectTo(type);

    mutate({
      request_followup: true,
    });
  };

  useEffect(() => {
    if (!isLoading && isSuccess && !!redirectTo) {
      queryClient.invalidateQueries({ queryKey: ["user"] });
      const timeout = setTimeout(() => {
        if (redirectTo === "dashboard") {
          navigate("/");
        }
        if (redirectTo === "fact-find") {
          navigate("/fact-find");
        }
      }, 500);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, redirectTo, navigate]);

  return !isLoading && !loading ? (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[416px] md:overflow-hidden md:my-4 w-full pb-10 mx-auto md:border md:border-pn_gray-200 bg-pn_paper-1 rounded-3xl">
        <Box className="w-full relative overflow-hidden">
          <div className="rounded-2xl relative">
            <ImageWithFallback
              src={RequestFollowUpIllustration || "/placeholder.svg"}
              alt="Verify email"
              width="100%"
              height="auto"
              loading="eager"
            />
            <div className="rounded-full bg-[#F4E34E] w-[80px] h-[80px] flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <PennyIcon />
            </div>
          </div>
        </Box>

        <div className="px-4">
          <div className="py-6 flex flex-col gap-y-8">
            <div className="flex flex-col gap-y-4">
              <span className="text-pn-large-title max-w-[195px] w-full">
                You're all set. Time to go!
              </span>
              <span className="text-pn-body-regular !font-normal text-pn_gray-600">
                We know your time is precious, we've got a few short 'pre-call'
                questions so you get the most out of a chat with your adviser.
              </span>
            </div>
            <div className="flex flex-col gap-y-4 text-center">
              <button
                onClick={() => handleRequestedFollowUp("fact-find")}
                className="btn-primary-lg"
              >
                Answer Short Survey
              </button>
              <button
                onClick={() => handleRequestedFollowUp("dashboard")}
                className="btn-secondary-lg"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Loading
      messages={{
        title: "Loading...",
        subtitle: `We are preparing the page...`,
      }}
    />
  );
};

export default RequestFollowUp;